import Api from '@/resource/Api';
import store from '@/store';
import Helper  from '@/resource/Helper';

export async function switchAccount(agent_email) {
    const url = 'v3/switch-rep-account';
    let loader;
    try {
        loader = this.$loading.show({
            canCancel: false,
            onCancel: () => {}
        });
        const data = {
            email: agent_email,
            user_type: 'A'
        };
        const res = await Api.post(url, data);
        if (res?.data?.status === 'success') {
            store.commit('setAuthentication', true);
            const switchSuccess = Helper.switchAccount(res.data);
            if (!switchSuccess) {
                throw new Error('Failed to switch account state');
            }
            // await Helper.dashboardGetters();
            this.$notify('Successfully switched account', 'success');
            return true;
        } else {
            throw new Error(res?.data?.message || 'Invalid response from server');
        }
    } catch (err) {
        console.error('Account switch error:', err);
        this.$notify(
            'Failed to switch account. Please try again.',
            'error'
        );
        return false;
    } finally {
        if (loader) {
            loader.hide();
        }
    }
}

export async function switchAccountAdmin(switch_id) {
    const url = 'v1/admin-switch-login';
    try {
        const data = {
            switch_id: switch_id
        };
        const res = await Api.post(url, data);
        if (res?.data?.status === 'success') {
            store.commit('setAuthentication', true);
            const switchSuccess = Helper.switchAccount(res.data);
            if (!switchSuccess) {
                throw new Error('Failed to switch account state');
            }
            // await Helper.dashboardGetters();
            this.$notify('Successfully switched account', 'success');
            return true;
        } else {
            throw new Error(res?.data?.message || 'Invalid response from server');
        }
    } catch (err) {

        console.error('Account switch error:', err);
        this.$notify(
            err?.response?.data?.message || 'Failed to switch account. Please try again.',
            'error'
        );
        this.$router.replace("/login");
    }
}
